export default __webpack_public_path__ + "static/media/tp-prof-liberal.16d978fc.webp";